(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scent-discovery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const choice=event.target.closest('[data-family]');if(!choice)return;const root=choice.closest('[data-signature-finder]');if(!root)return;event.preventDefault();const family=choice.dataset.family;root.querySelectorAll('[data-family]').forEach(link=>link.setAttribute('aria-current',String(link===choice)));let shown=0;root.querySelectorAll('[data-finder-product]').forEach(card=>{const match=family==='all'||card.dataset.tags.split(',').includes(family);card.hidden=!match||shown>=3;if(!card.hidden)shown++});root.querySelector('[data-finder-empty]').hidden=shown>0;root.querySelector('[data-finder-all]').href=choice.href});

  } catch(e) { console.error(e); }
})();
})();
